import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import moment from 'moment';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { ResignationService } from 'src/app/shared/services/resignservices/resignation.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-resignation-apply',
  templateUrl: './resignation-apply.component.html',
  styleUrls: ['./resignation-apply.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule,],
  providers: [DatePipe],
})
export class ResignationApplyComponent implements OnInit {

  showSpinner = false;
  selectedMode: any;
  datamode: any;
  user: any;
  userInfo: any;
  colormode: any;

  constructor(public datePipe: DatePipe,
    private router: Router,
    private resignService: ResignationService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  calculateLastWorkingDay(form: NgForm) {
    const model = form.value;
    const remainingDays = model.employment_status == "Permanent" ? 30 : 7;
    const lastDay = moment(model.resign_date).add(remainingDays, 'days').toDate();
    form.controls.last_working_date.setValue(this.datePipe.transform(lastDay, 'yyyy-MM-dd'));
  }

  onSubmit(form: NgForm) {
    const model = form.value;
    const date = new Date();
    const currentDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    const resinationDate = new Date(model.resign_date);
    if (resinationDate.getTime() < currentDate.getTime()) {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/warning_icon.svg"  alt="image" >',
        title: "Please select today's date or future date.",
        showConfirmButton: false,
        timer: 3000,
      });
    }
    else {
      model.resign_date = this.datePipe.transform(model.resign_date, 'yyyy-MM-dd HH:mm:ss');
      model.last_working_date = this.datePipe.transform(model.last_working_date, 'yyyy-MM-dd HH:mm:ss');
      this.showSpinner = true;
      this.resignService.applyResign(model).subscribe(response => {
        this.showSpinner = false;
        if (response.success) {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Resignation Submitted Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          this.router.navigate(['/dashboard-1']);
        }
        else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: response.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    }
  }

  onCancel(form: NgForm) {
    form.reset();
    this.router.navigate(['/dashboard-1']);
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
}
